import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useDropdownContext } from './DropdownContext';
/**
 * DropdownMenu is a container for the overlay portion of a Dropdown.
 */
export function DropdownMenu({ children }) {
    const { isActive } = useDropdownContext();
    if (!isActive) {
        return null;
    }
    return _jsx(_Fragment, { children: children }, void 0);
}
//# sourceMappingURL=DropdownMenu.js.map